import { scrollAnimate } from "../components/scrollAnimate";
import {
    GTM_SUCCESS,
    GTM_ERROR,
} from "../utilities/constants";

const $cache = {
    document: $(document)
};

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessage(data) {
    if (data.success) {
        const $newsLetterWrapper = $(".newsletter-wrapper");
        const $newsLetterWrapperText = $newsLetterWrapper.find(".newsletter-text");
        const msg = $newsLetterWrapperText.find(".success").text();
        $newsLetterWrapper.find(".newsletter-email-input").addClass("d-none");
        $newsLetterWrapper.find(".newsletter-button-wrap").addClass("d-none");
        $newsLetterWrapper.find(".newsletter-title").addClass("is-success");
        $newsLetterWrapperText.removeClass("d-none");

        //GTM logic - Start
        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
            detail: {
                "success": true,
                "messageContent": msg
            }
        }));
        //GTM logic - End

    } else if (!data.success && data.serviceError) {
        const $serviceErrorModal = $("#service-error-general");

        $serviceErrorModal.modal("show");
        $serviceErrorModal.on("shown.bs.modal", () => {
            $serviceErrorModal.find(".js-service-error-msg").html(data.msg);
            //GTM logic - Start
            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                detail: {
                    "success": false,
                    "messageContent": data.msg
                }
            }));
            //GTM logic - End
        });
    }

    document.dispatchEvent(new CustomEvent("dataLayer.newsletter", {
        detail: {
            "subscriptionMessage": data.success ? GTM_SUCCESS : GTM_ERROR
        }
    }));
}

/**
 * Shows consent text
 */
const showConsentDetails = () => {
    const $userSubscriptionConsent = $(".newsletter-customer-consent");
    $userSubscriptionConsent.removeClass("d-none");
    $userSubscriptionConsent.closest(".newsletter-wrapper").addClass("is-consent-show");
};

module.exports = function () {
    if ($(".back-to-top")) {
        const $backToTopButton = $(".back-to-top");
        let triggerOffset = window.innerHeight;
        if (window.innerHeight == null || window.innerHeight == undefined) triggerOffset = 720;

        $cache.document.on("scroll", () => {
            if (window.pageYOffset > triggerOffset && $backToTopButton) $backToTopButton.removeClass("d-none").addClass("d-flex");
            if (window.pageYOffset < triggerOffset && $backToTopButton) $backToTopButton.removeClass("d-flex").addClass("d-none");
        });

        $backToTopButton.click(() => {
            scrollAnimate();
        });
    }


    $(".subscribe-email").on("click", function (e) {
        e.preventDefault();
        var url = $(this).data("href");
        var emailId = $("input[name=hpEmailSignUp]").val();
        const newsletterCheckbox = $("#newsletter-checkbox");
        const isChecked = newsletterCheckbox.is(":checked");
        const consentData = newsletterCheckbox.data("consent");
        var csrfInput = $(".newsletter-csrf");
        var consentTextElement = $(".newsletter-customer-consent .pwc-form-check-label .content-asset");
        var consentTextHtml = consentTextElement.prop("outerHTML");
        var consentTextString = consentTextHtml.toString();
        var consentText = consentTextString.replace(/(<([^>]+)>)/ig, "");

        var dataObj = {
            emailId: emailId,
            isChecked: isChecked,
            consent: JSON.stringify(consentData),
            consentText: consentText
        };

        dataObj[csrfInput.attr("name")] = csrfInput.val();

        if (emailId == "") { return; }
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            data: dataObj,
            success: function (data) {
                displayMessage(data);
            },
            error: function (err) {
                displayMessage(err);
            }
        });
    });

    /**
     * Makes request to the server to get consent message
     */
    $cache.document.on("focusin", "#input-custom-label-newsletter", () => {
        const $consentWrapper = $(".newsletter-customer-consent");
        const url = $("#input-custom-label-newsletter").data("consent-url");

        try {
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    $consentWrapper.find("#newsletter-checkbox").attr("data-consent", JSON.stringify(data.consents));
                    showConsentDetails();
                });
        } catch (e) {
            console.error(e);
        }
    });

    const $customerConcentCheck = $(".js-customer-consent");
    if ($customerConcentCheck) {
        $customerConcentCheck.parent().find(".pwc-form-input").on("click", e => {
            e.preventDefault();
            if ($customerConcentCheck.hasClass("d-none")) $customerConcentCheck.removeClass("d-none");
        });
    }

};
